import React, { useEffect, useRef, useState } from 'react';
import './LoadingBar.css'; // Estilos específicos para o componente

export default function LoadingBar({ duration, counting, label, orderId, onFinish }) {
  const [progress, setProgress] = useState(0);
  const [remaining, setRemaining] = useState(duration);
  const [checkPaid, setCheckPaid] = useState(true);
  const animationRef = useRef(null);

  useEffect(() => {
    let interval;
    
    if (counting) {
      setProgress(0);
      setRemaining(duration);
      
      // Animação de progresso usando requestAnimationFrame
      const startTime = Date.now();
      const endTime = startTime + duration;
      
      const animate = () => {
        const now = Date.now();
        const elapsed = now - startTime;
        const newProgress = Math.min(elapsed / duration, 1);
        
        setProgress(newProgress);
        setRemaining(Math.max(0, endTime - now));
        
        if (now < endTime) {
          animationRef.current = requestAnimationFrame(animate);
        } else {
          setRemaining(0);
        }
      };
      
      animationRef.current = requestAnimationFrame(animate);
      
      // Intervalo para verificar pagamento
      interval = setInterval(() => {
        setRemaining((prev) => {
          if (prev <= 1000) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1000;
        });
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    };
  }, [counting, duration]);

  useEffect(() => {
    if (remaining > 0 && remaining % 5000 === 0 && checkPaid) {
      // Simulação da chamada à API (substitua pela sua implementação real)
      // apiFetch.get('/pagarMe?order_id='+orderId).then(r => {
      //   if(r.status === 'paid'){
      //     onFinish('pago', {paid_at: r.charges[0].paid_at, code: r.charges[0].code, order_id: orderId})
      //     setCheckPaid(false)
      //   }
      // })
    }
    else if (remaining === 0) {
      setCheckPaid(false)
      if (onFinish) onFinish('expirado', {order_id: orderId});
    }
  }, [remaining, checkPaid, onFinish, orderId])

  if (!counting) return null;

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60)
      .toString()
      .padStart(2, '0');
    const seconds = (totalSeconds % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  return (
    <div className="loading-bar-wrapper">
      <div className="loading-bar-container">
        <div 
          className="loading-bar-progress"
          style={{ width: `${progress * 100}%` }}
        />
      </div>
      <div className="loading-bar-text">
        {`${label || ''}${formatTime(remaining)}`}
      </div>
    </div>
  );
}